import Vue, { createApp } from "vue"
import TreesPartialComponents from "./plugins/trees"
import AppLayout from "./components/shared/AppLayout.vue"
import "./tailwind.css"
import "vue-multiselect/dist/vue-multiselect.css"
import "balloon-css/balloon.min.css"
import "flatpickr/dist/flatpickr.min.css"
import * as Sentry from "@sentry/vue"
import { useAppFlashes } from "@xy-planning-network/trees"

// configure default email for generic error flashes
useAppFlashes().configure({ email: "archive@xyplanningnetwork.com" })

const initVueApp = (component: Vue.Component): void => {
  const app = createApp(component, window.InitialVueProps)

  // Global component registration
  app.component("AppLayout", AppLayout)

  // Trees Global Components - cherry picked
  app.use(TreesPartialComponents)

  // Init sentry for automated error notifications
  if (import.meta.env.MODE !== "development") {
    let sentryIntegrations = null
    const currentUserAvail = window.InitialVueProps?.initialProps?.currentUser

    if (import.meta.env.MODE === "production") {
      sentryIntegrations = currentUserAvail
        ? [new Sentry.Replay({ maskAllText: false, maskAllInputs: false })]
        : null
    }

    Sentry.init({
      app: app,
      dsn: "https://747d6c6ae408408c8d4a7dcb9943a2cd@sentry.io/1813622",
      allowUrls: [/^https?:\/\/(([A-Za-z0-9-]*)\.)?xyplanningnetwork\.com/],
      environment: import.meta.env.MODE.toUpperCase(),
      replaysSessionSampleRate: 1.0,
      tracesSampleRate: 1.0,
      logErrors: true,
      trackComponents: true,

      integrations: sentryIntegrations,
    })
    if (currentUserAvail) {
      const user = window.InitialVueProps.initialProps.currentUser
      Sentry.setUser({ email: user.email, id: user.id })
    }
  }

  app.mount("#vue-app")
}

export default initVueApp
